import React, {useRef, useState, useEffect} from "react";
import {useAuth} from "../contexts/AuthContext";
import {Alert, Button, Card, Form, Spinner} from "react-bootstrap";
import { Link } from "react-router-dom";
import {addNewRide, getAllTests} from "../contexts/RidesContext";
import { Typeahead } from 'react-bootstrap-typeahead';
import {getUserData} from "../contexts/UsersContext";
import {testsCompareFunction} from "../utils";


export default function NewRide() {
    const emailRef = useRef()
    const { currentUser } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [vacantSeats, setVacantSeats] = useState(-1)
    const [tests, setTests] = useState([])
    const [testStringSelection, setTestStringSelection] = useState([])
    const [selectedTestId, setSelectedTestId] = useState(-1)
    const [selectedTestDate, setSelectedTestDate] = useState("")
    const [successMessage, setSuccessMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [address, setAddress] = useState("")
    const [driverCity, setDriverCity] = useState("")
    const [name, setName] = useState("")

    useEffect(() => {
        const fetchTests = async () => {
            const testsList = await getAllTests();
            const sortedTestsList = testsList.sort(testsCompareFunction);
            setTests(sortedTestsList);
        }
        const fetchLoggedInUSerData = async () => {
            const userData = await getUserData(currentUser.email);
            const userFullName = userData.first_name + " " + userData.last_name;
            const userAddress = userData.street + " " + userData.house_number + " " + userData.city
            setPhoneNumber(userData.phone_number);
            setAddress(userAddress);
            setName(userFullName);
            setDriverCity(userData.city);
        }
        fetchTests().catch(console.error);
        fetchLoggedInUSerData().catch(console.error);
    }, []);

    useEffect(() => {
        const selectedId = testStringSelection.toString() ?  getTestIdFromTestString(testStringSelection.toString()) : -1;
        setSelectedTestId(selectedId);
        // eslint-disable-next-line
    }, [testStringSelection]);

    useEffect(() => {
    const selectedTest = tests.find(test => test.id === selectedTestId);
    if (selectedTest) {
        const selectedDate = selectedTest.data().date_time.toDate();
        const selectedDateString = selectedDate.toLocaleString(`he-IL`).replace(/\./g,'/');
        setSelectedTestDate(selectedDateString);
    }
        // eslint-disable-next-line
    }, [selectedTestId]);

    async function handleNewRide(e) {
        e.preventDefault();
        setLoading(true)
        try {
            const docRef = await addNewRide(currentUser.uid, selectedTestId, address, vacantSeats, driverCity, currentUser.email);
            console.log(`received doc ID: ${docRef}`);
            setSuccessMessage("Successfully created new ride!")
        } catch (e) {
            setError("failed to add new drive");
        } finally {
            setLoading(false);
        }
    }

    function testString(test) {
        const testData = test.data();
        return `${testData.course_number} ${testData.course_name}, moed ${testData.date_in}`;
    }

    function getTestIdFromTestString(testString) {
        const courseNumber = testString.split(' ')[0];
        const selectedTest = tests.find(test => test.data().course_number === courseNumber);
        return selectedTest.id;
    }

    return(
        <>
            <Card className="text-center" style={{ width: '40rem' }}>
                <Card.Body>
                    <h2 className="text-center mb-4">Register New Ride</h2>
                    <Form onSubmit={handleNewRide}>
                        <h5>Ride Details</h5>
                        <Form.Group>
                            <Form.Label>Test you're driving to</Form.Label>
                            <Typeahead
                                id="chooseTest"
                                labelKey="name"
                                onChange={setTestStringSelection}
                                options={tests.map(test => testString(test))}
                                placeholder="Search by course id/name..."
                                selected={testStringSelection}
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group id="testDateTime">
                            <Form.Label>Test Date & Time</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={selectedTestDate}
                                disabled
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group id="vacantSeats">
                            <Form.Label>Vacant Seats</Form.Label>
                            <Form.Select onChange={e => setVacantSeats(parseInt(e.target.value))}>
                                required
                                <option>number of vacant seats</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </Form.Select>
                        </Form.Group>
                        <br/>
                        <Form.Group id="driverLocation">
                            <Form.Label>Departure Location</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Your address..."
                                value={address}
                                onChange={e => setAddress(e.target.value)}
                            />
                        </Form.Group>
                        <br/>
                        <br/>
                        <h5>Driver Info</h5>
                        <Form.Group id="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Your name..."
                                value={name}
                                disabled
                            />
                        </Form.Group>
                        <br/>
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                ref={emailRef}
                                required
                                defaultValue={currentUser.email}
                                disabled
                            />
                        </Form.Group>
                        <br></br>
                        <Form.Group id="Phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                type="tel"
                                value={phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                                disabled
                            />
                        </Form.Group>
                        <br></br>
                        <br></br>
                        <Button disabled={loading || selectedTestId < 0 || vacantSeats < 0} className="w-100" type="submit">
                            Register Ride
                        </Button>
                        <br/>
                        <br/>
                        {successMessage && <Alert variant='success'>{successMessage}</Alert>}
                        {loading && <Alert variant='info'>Creating your ride... Hang tight  <Spinner animation="border"/></Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}
                    </Form>
                </Card.Body>
            </Card>
            <div className="w-100 text-center mt-2">
                <Link to="/">Back</Link>
            </div>
        </>
    )
}